import { createContext } from 'react'

/**
 * **Die Liste gibt ihre Tastatur zurück** (#284): Ein Dropdown an einer Zeile (Marke, Kürzel-Kasten)
 * hält beim Schließen den Fokus im Portal, React hängt den Inhalt aus, und er fällt auf `body`. Die
 * Aufgabe bleibt markiert, aber kein Wrapper bekommt die Taste — die Pfeile scrollen die Seite.
 *
 * Die Liste (`TaskBoard`, `TaskList`) stellt den Weg bereit, das `TaskDropdown` ruft ihn beim Schließen.
 * **Ohne Liste** (Schnelleingabe, Aufgaben-Details, Storybook) ist der Wert `null`, und nichts passiert —
 * die Hülle kennt die Liste nicht.
 */
export const ListFocusContext = createContext<(() => void) | null>(null)

/**
 * Setzt den Fokus auf den Wrapper der Liste — **nur wenn er verloren ist** (`body`) oder auf einer
 * Zeile steht (#243 nach dem Ziehen, #284 nach einem Dropdown). Ein Feld und eine aufgeklappte Karte
 * behalten ihn; ebenso ein anderes Dropdown, das gerade aufgeht (Wechsel zwischen zwei Marken).
 */
export function restoreFocusToList(wrapper: HTMLElement | null): void {
  if (!wrapper) return
  if (document.querySelector('[data-task-dropdown]')) return
  const current = document.activeElement as HTMLElement | null
  const lost = !current || current === document.body
  const onRow = !!current
    && wrapper.contains(current)
    && !current.closest('.task-entry--expanded')
    && !(current.tagName === 'INPUT' || current.tagName === 'TEXTAREA' || current.isContentEditable)
  if (lost || onRow) wrapper.focus({ preventScroll: true })
}
